export const SAVE_FILTERS = '@filters/saveFilters';

export function saveFilters(payload) {
  return {
    type: SAVE_FILTERS,
    payload,
  };
}
